/**
 * Frontend parameter builders for job fetching
 * 
 * These functions now use the shared buildJobIndexParams from @artha/utils
 * to ensure consistency with backend parameter building.
 * 
 * Deprecated functions are kept for backward compatibility during migration.
 */

import type { Creator, CreatorProfileForMyLink } from "@artha/types";
import type { JobIndexParams, JobIndexParamsInput } from "./types";
import { buildJobIndexParams as buildJobIndexParamsShared } from "@artha/utils";

/**
 * Build parameters for authenticated job fetching
 * Uses shared utility from @artha/utils for consistency with backend
 * 
 * @param creator - Creator object
 * @param params - User-applied filters
 * @returns Normalized job index parameters
 */
export function buildJobIndexParams({
  creator,
  params = {},
}: {
  creator?: Creator | CreatorProfileForMyLink | null;
  params?: JobIndexParamsInput;
}): JobIndexParams {
  return buildJobIndexParamsShared({ creator, params });
}

/**
 * Build parameters for public profile job fetching
 * Uses merge mode so creator defaults are always preserved
 * and candidate filters are added on top (union for arrays).
 *
 * @param creator - Creator profile object
 * @param userFilters - Candidate-applied filters from UI
 * @returns Normalized job index parameters (creator defaults + candidate filters)
 */
export function buildPublicJobParams({
  creator,
  userFilters = {},
}: {
  creator?: CreatorProfileForMyLink | null;
  userFilters?: JobIndexParamsInput;
}): JobIndexParams {
  return buildJobIndexParamsShared({
    creator,
    params: userFilters,
    merge: true, // Merge candidate filters with creator defaults
  });
}
